import React from 'react';
import { Alert, Badge } from 'reactstrap';

export default function WatcherList({ watchers = [], onRemove, error, onDismissError }) {
  return (
    <div>
      {error && (
        <Alert color="danger" toggle={onDismissError} className="mb-2">
          {error}
        </Alert>
      )}
      <div className="d-flex flex-wrap gap-1">
        {watchers.map((w) => (
          <Badge
            key={w.userId}
            color="light"
            className="text-dark d-inline-flex align-items-center"
          >
            {w.userName || w.userId}
            <button
              type="button"
              className="btn-close btn-close-sm ms-1"
              aria-label={`Remove ${w.userName || w.userId}`}
              onClick={() => onRemove(w.userId)}
            />
          </Badge>
        ))}
      </div>
    </div>
  );
}
